import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import getMediaQuery from "css/breakpoints"

import DescItem from "./DescItem"
import DescFigure from "./DescFigure"

const List = styled.dl`
  grid-column: col 1 / col -1;
  grid-row: desclist;
  margin: 0;

  ${getMediaQuery("m")} {
    grid-column: col 7 / span 6;
  }
`

export default function SpecsFeaturesDesktop({ spec_items }) {
  const console = useConsole()

  console.verbose("••• SpecsFeatures", spec_items)

  return (
    <>
      <List>
        {spec_items.map(({ term_marker, term, description, _metadata }, i) => (
          <DescItem key={`feature-spec-${i}`} index={i} term_marker={term_marker} term={term} description={description} meta={_metadata} />
        ))}
      </List>
      {spec_items.map(({ image_cld: image, video_cld: video }, i) => (
        <DescFigure key={`feature-spec-fig-${i}`} index={i} image={image} video={video} />
      ))}
    </>
  )
}
